/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import activeStep from '../../../assets/fibe-ui/activeStep.svg';
import inActiveStep from '../../../assets/fibe-ui/inActiveStep.svg';

// IMPORTS: Image for steps progress representation
import ActiveStepIcon from '../../../assets/fibe-ui/active-step-icon.svg';
import InactiveStepIcon from '../../../assets/fibe-ui/inactive-step-icon.svg';
import CompletedStepIcon from '../../../assets/fibe-ui/completed-step-icon.svg';
import FailedStepIcon from '../../../assets/fibe-ui/failed-step-icon.svg';

export default function ConvUiSteps({ stepsArray }) {
  const getImageByStepStatus = (stepStatus) => {
    switch (stepStatus) {
      case 'COMPLETED':
        return CompletedStepIcon;
      case 'FAILED':
        return FailedStepIcon;
      case 'ACTIVE':
        return ActiveStepIcon;
      case 'INACTIVE':
        return InactiveStepIcon;
      default:
        return InactiveStepIcon;
    }
  };
  return (
    <div>
      {stepsArray.map((step, index) => (
        <div className="flex items-center gap-4 relative" key={step.stepName}>
          <div
            className={`w-[2px] h-[4.5rem] bg-background-stroke absolute left-[7%] bottom-[-8%] ${
              stepsArray.length - 1 === index && 'hidden'
            }`}
          />
          <img
            className="mb-16 z-0"
            src={getImageByStepStatus(step.completionStatus)}
            alt="Active step icon"
            width="24px"
            height="24px"
          />
          <p className="mb-16">{step.stepName}</p>
        </div>
      ))}
    </div>
  );
}
